import { useAppState } from 'hooks/useAppState';

export const useUserToDeleteId = () => {
  const { userToDeleteId } = useAppState();

  return userToDeleteId;
};
